import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const singlePublisherUserAction = createAsyncThunk(
    'single-publisher-user',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/single-publisher-users?publisher_id=${data?.publisher_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const singlePublisherUserSlice = createSlice({
    name: 'single-publisher-user',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(singlePublisherUserAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(singlePublisherUserAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(singlePublisherUserAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const singlePublisherUserReducer = singlePublisherUserSlice.reducer